export const environment = {
  production: false,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '/',
  appId: 'zAppDevManager_578_d.moudilos@clmsuk.com',
  defaultPage: 'HomePage',
  windowsAuthentication: false,
  semanticVersion: '639111419520967284'
};